import { Component, Input, Output, forwardRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { FCEVENT } from '../fc';
import { NzModalService } from 'ng-zorro-antd';
/* é«çº§ç»ä»¶-å¾çä¸ä¼ åè½®æ­ç»ä»¶ */
@Component({
    selector: 'fc-adcarousel',
    template: `
    <div class="fc-adcarousel">
        <div class="fc-adcarousel-carousel">
            <fc-carousel [fcData]="fcData" [fcAutoPlay]="fcAutoPlay" [fcSlickGoTo]="fcSlickGoTo" ></fc-carousel>
        </div>
        <div class="fc-adcarousel-upload">
            <fc-upload  fcLabel="åºæ¬"  [fcListType]="'picture-card'" [fcOption]="fcOption" [fcPreview]="false"
            (fcEvent)="uploadEvent($event)">
            </fc-upload>
        </div>
    </div>
    `,
    styles: [`
    .fc-adcarousel-upload{
        padding-top:5px;
    }
    :host ::ng-deep .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye-o,
    :host ::ng-deep .ant-upload-list-picture-card:hover .ant-upload-list-item-actions .anticon-eye-o{
        width: 96px;
        height: 96px;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        color: transparent;
    }
    :host ::ng-deep .ant-upload-list-picture-card .ant-upload-list-item-actions {
        position: absolute;
        left: 0;
        top: 0;
        transform: translate(0, 0);
        width: 96px;
        height: 96px;
        display: block;
        transition: all 0s;
    }
    :host ::ng-deep .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete{
        position: absolute;
        right: 10px;
        top: 10px;
    }
    :host ::ng-deep .fc-adcarousel .slick-slide img{
        width:auto;
        height:100%;
        display:block;
        margin:auto;
    }
    `]
})
export class FcadcarouselComponent extends FcinputComponent {
     /** æ°å¼ */
    @Input()
    fcData: any[];
    _fcData: any[];
     /** èªå¨æ­æ¾ */
    @Input()
    fcAutoPlay: string;
    _autoplay: boolean;
    /** è½®æ­å¾è·³è½¬å°æå®çç´¢å¼ */
    @Input()
    fcSlickGoTo: string;
    _slickGoTo: string;
    constructor(public provider: ProvidersService, private confirmServ: NzModalService) {
        super(provider, 'fc-adcarousel');
    }
  /**
    * ä¸ä¼ å¾ç
    * @param event äºæ
    */
    uploadEvent(event: FCEVENT) {
        switch (event.eventName) {
            case "selectedPic": /** éä¸­å¾ç */
                this.event('selectedPic', event);
                for (let i = 0; i < this._fcData.length; i++) {
                    if (this._fcData[i].uid === event.param.uid) {
                        this._slickGoTo = i + "";
                        break;
                    }
                }
                break;
            case 'loaded':
                this._fcData = [];
                this._processPic(event.param);
                break;
            case 'removeFile':
                this._fcData = [];
                this._processPic([event.param]);
                break;
            case 'success':
                this._processPic([event.param]);
                break;
        }
    }
    /**
     * å¤çå¾ç
     * @param pics uploadç»ä»¶ä¸­è·åçå¾ç
     */
    private _processPic(pics: any[]) {
        pics = pics || [];
        pics.forEach(item => {
            this._fcData.push({
                uid: item.uid,
                label: item.name,
                src: item.url
            });
        })
    }
    _afterParentInit() {
         /** if (this.fcData !== undefined) { */
         /**     this._fcData = this.fcData; */
         /** } */
    }
}
